import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Index from '../views/Index.vue'
import Character from '../views/Character.vue'
import IntroParadigm from '../views/IntroParadigm.vue'
import IntroClass from '../views/IntroClass.vue'
import IntroCharacter from '../views/IntroCharacter.vue'
import WorldPreview from '../views/WorldPreview.vue'
import Showcase from '../views/Showcase.vue'
import Showcase2nd from '../views/Showcase2nd.vue'
import Clip from '../views/Clip.vue'
import ClipMobile from '../views/ClipMobile.vue'
//import Media from '../views/Media.vue'
import ComingSoon from '../views/ComingSoon.vue'
import Purple from '../views/Purple.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/event/teasing/index',
    name: 'index',
    components: {
      default: Index,
      mobile: Index
    }
  },
  /*
  {
    path: '/event/teasing/character',
    name: 'character',
    components: {
      default: Character,
      mobile: Character
    }
  },*/
  {
    path: '/event/teasing/showcase2nd',
    name: 'showcase2nd',
    components: {
      default: Showcase2nd,
      mobile: Showcase2nd
    }
  },
  {
    path: '/event/teasing/showcase',
    name: 'showcase',
    components: {
      default: Showcase,
      mobile: Showcase
    }
  },
  {
    path: '/event/teasing/introcharacter',
    name: 'introcharacter',
    components: {
      default: IntroCharacter,
      mobile: IntroCharacter
    }
  },
  {
    path: '/event/teasing/worldpreview',
    name: 'worldpreview',
    components: {
      default: WorldPreview,
      mobile: WorldPreview
    }
  },
  {
    path: '/event/teasing/introclass',
    name: 'introclass',
    components: {
      default: IntroClass,
      mobile: IntroClass
    }
  },
  {
    path: '/event/teasing/paradigm',
    name: 'paradigm',
    components: {
      default: IntroParadigm,
      mobile: IntroParadigm
    }
  },
  {
    path: '/event/teasing/clip',
    name: 'clip',
    components: {
      default: Clip,
      mobile: ClipMobile
    }
  },
  // {
  //   path: '/event/teasing/media',
  //   name: 'media',
  //   components: {
  //     default:Media,
  //     mobile:Media
  //   }
  // },
  /*
  {
    path: '/event/teasing/comingsoon',
    name: 'comingsoon',
    components: {
      default: ComingSoon,
      mobile: ComingSoon
    }
  },*/
  {
    path: '/event/teasing/purple',
    name: 'purple',
    components: {
      default: Purple,
      mobile: Purple
    }
  },
  {
    path: '*',
    component: Index,
    components: {
      default: Index,
      mobile: Index
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  if (store.state.isMovePage) return;
  if (store.state.isLayer) return;
  if (to.name == from.name && from.name != null) {
    router.history.current.query.page = to.query.page
    window.history.replaceState(null, null, '?page=' + to.query.page);
    store.commit('setClipQuery', to.query.page);
    return;
  } else {
    store.commit('setClipQuery', 0);
  }
  next();
})

export default router
